import { Navigate, useParams, useSearchParams } from "react-router-dom";

const todayIsoDate = () => new Date().toISOString().slice(0, 10);

function DailyReportingEmployee() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const date = searchParams.get("date") || todayIsoDate();

  return <Navigate to={`/daily-reporting?employee=${id}&date=${date}`} replace />;
}

export default DailyReportingEmployee;
